<!--
  A pointer-transparent full-viewport layer; only Buddy's own surfaces take events,
  so the ERP underneath stays fully usable.
-->
<div class="host" [style.zIndex]="zIndex">

  <!-- Collapsed: corner bubble (default) or edge tab. -->
  <div class="host__slot" *ngIf="!panelOpen && !useEdgeTab" [ngStyle]="bubbleStyle">
    <app-buddy-bubble
      [bbState]="bbState"
      [stage]="progress.stage"
      [xpPct]="xpPct"
      [attention]="hasAttention"
      [dragging]="dragging"
      (opened)="openPanel()"
      (dragStarted)="startBubbleDrag($event)"
    ></app-buddy-bubble>
  </div>

  <div class="host__slot" *ngIf="!panelOpen && useEdgeTab" [ngStyle]="edgeTabStyle">
    <app-buddy-edge-tab
      [bbState]="bbState"
      [stage]="progress.stage"
      [xpPct]="xpPct"
      [pendingCount]="pendingCount"
      [edge]="placement.edge"
      (opened)="openPanel()"
    ></app-buddy-edge-tab>
  </div>

  <!-- Expanded panel. -->
  <div
    class="host__panel"
    *ngIf="panelOpen"
    [class.host__panel--waking]="waking"
    [class.host__panel--dragging]="dragging"
    [ngStyle]="panelStyle"
  >
    <app-buddy-panel
      *ngIf="layout === 'panel'"
      [density]="density"
      (dragStarted)="startPanelDrag($event)"
      (collapseRequested)="closePanel()"
      (edgeToggleRequested)="toggleEdge()"
      (layoutToggleRequested)="toggleLayout()"
    ></app-buddy-panel>

    <!-- 1c: the quest-rail sidebar. -->
    <app-buddy-rail
      *ngIf="layout === 'rail'"
      [density]="density"
      (dragStarted)="startPanelDrag($event)"
      (collapseRequested)="closePanel()"
      (edgeToggleRequested)="toggleEdge()"
      (layoutToggleRequested)="toggleLayout()"
    ></app-buddy-rail>

    <!-- Resize handle, on whichever corner faces away from the docked edge. -->
    <div
      class="host__resize"
      [class.host__resize--left]="placement.edge === 'right'"
      role="separator"
      aria-label="Resize Buddy"
      (pointerdown)="startResize($event)"
    ></div>
  </div>
</div>
